<template>
    <v-app>
        <div id="app">
            <v-snackbar
                    v-model="numberSavedSuccess"
                    :bottom="y === 'bottom'"
                    color="green"
                    :timeout="timeout"
                    :top="y === 'top'"
            >
                <v-icon style="color: white; padding-right: 2vw">done</v-icon> Changes Saved
                <v-btn
                        color="white"
                        text
                        @click="numberSavedSuccess = false"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
            <v-navigation-drawer
                    hide-overlay
                    right
                    v-model="drawer"
                    absolute
                    temporary
                    color="#2e2e2e"
                    floating
                    id="navigation-drawer"
            >
                <div id="navigation-drawer-top-area">
                    <div class="navigation-drawer-top-section">
                        <v-btn dark x-small @click="drawer = false"  icon><v-icon>fas fa-angle-right</v-icon></v-btn>
                    </div>
                    <div class="navigation-drawer-top-section">
                        <v-icon small style="font-size:3.5vh; color:white">fab fa-paypal</v-icon>
                    </div>
                    <div class="navigation-drawer-top-section">
                        <v-btn  dark x-small @click="triggerDarkMode()" icon><v-icon style="color:white">{{darkModeIcon}}</v-icon></v-btn>
                    </div>
                </div>
                <hr>
                <v-list v-if="isAdmin" height="50px" rounded>
                        <v-list-item-group v-model="showSelectedPage" mandatory color="white">
                    <v-list-item style="height: 7.5px"
                            v-for="item in accountOptions"
                            link
                            ripple
                            :value="item.page"
                    >
                        <v-list-item-icon>
                            <v-icon class="navigation-drawer-icons">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  style="color: white">{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    </v-list-item-group>
                </v-list>
                <v-list v-else height="50px" rounded>
                    <v-list-item-group v-model="showSelectedPage" mandatory color="white">
                        <v-list-item style="height: 7.5px"
                                     v-for="item in callCentreAccountOptions"
                                     link
                                     ripple
                                     :value="item.page"
                        >
                            <v-list-item-icon>
                                <v-icon class="navigation-drawer-icons">{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title  style="color: white">{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
                <div id="drawer-version-section">
                  <v-scroll-x-transition>
                  <div v-if="enableGreeting" class="drawer-version-section-inner">
                    {{ greetingMessage }}
                  </div>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition>
                  <div v-if="showVersion" class="drawer-version-section-inner">
                    v1.2.0.5
                    <v-chip pill color="white" id="drawer-version-section-pill">
                        Beta
                    </v-chip>
                  </div>
                  </v-scroll-x-transition>
                </div>
            </v-navigation-drawer>
            <div v-resize="resizeWindow" id="panel-header">
                <v-slide-x-transition>
                    <v-card flat id="panel-header-content" color="rgba(0,0,0,0)" v-if="showPageNameToggle">
                        <div id="panel-viewing-page">
                            {{viewingPage}}
                        </div>
                    </v-card>
                </v-slide-x-transition>
                <div id="drawer-button-area">
                    <v-btn small  @click.stop="drawer = !drawer" icon text color="#FFFFFF">
                        <v-icon>fas fa-user-circle</v-icon>
                    </v-btn>
                </div>
            </div>
            <div id="panel-content">
                <div id="dashboard">
                    <v-slide-x-transition>
                    <v-card v-if="showContentToggle" id="main-parent-area">
                        <v-card flat v-if="openTakeMeHomePage" id="dashboard-info">
                        <div id="info-header">
                            <div id="header-text">
                                <div v-bind:style="{background: darkModeDarkSkinLighten}" id="text-functions">
                                    <div id="home-search-empty-area"></div>
                                    <div id="home-search-area">
                                        <v-menu dark
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                offset-y
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                        @click="stopInterval"
                                                        x-small
                                                        :color="colorModeButton"
                                                        dark
                                                        icon
                                                        v-on="on"
                                                >
                                                    <v-icon style="font-size: 2.5vh">fas fa-bars</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title style="font-weight: bold">Filter</v-list-item-title>
                                                            <v-list-item-subtitle>Filter the search results by clicking on the options below </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list>
                                                    <div id="home-search-list-card">
                                                        <div id="home-search-primary-filter">
                                                            <div class="search-primary-more">
                                                                <v-checkbox  v-model="filterByChat" color="white" label="Chat"></v-checkbox>
                                                            </div>
                                                            <div class="search-primary-more">
                                                                <v-checkbox v-model="filterByState" color="white" label="Status"></v-checkbox>
                                                            </div>
                                                        </div>
                                                        <div id="home-search-secondary-filter">
                                                            <div class="search-secondary-more">
                                                                <v-slide-x-transition>
                                                                    <v-radio-group v-if="filterByChat"  v-model="filterChatSelected" >
                                                                        <v-radio color="white"
                                                                                 v-for="n in chatOptions"
                                                                                 :label="n.title"
                                                                                 :key="n.id"
                                                                                 :value="n.id"
                                                                        ></v-radio>
                                                                    </v-radio-group>
                                                                </v-slide-x-transition>
                                                            </div>
                                                            <div class="search-secondary-more">
                                                                <v-slide-x-transition>
                                                                    <v-radio-group v-if="filterByState" v-model="filterStatusSelected">
                                                                        <v-radio color="white"
                                                                                 v-for="n in statusOptions"
                                                                                 :key="n.id"
                                                                                 :label="n.title"
                                                                                 :value="n.id"
                                                                        ></v-radio>
                                                                    </v-radio-group>
                                                                </v-slide-x-transition>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-list>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn :disabled="disableSetFilterButton" color="white" text @click="searchingParameterSet = true;menu = false;">Set</v-btn>
                                                    <v-btn text @click="searchingParameterSet = false; filterByState = false, filterByChat = false; ">Clear</v-btn>
                                                    <v-btn text @click="menu = false;">Close</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-menu>
                                    </div>
                                    <div id="filter-category">
                                        <input @focus="stopInterval" v-bind:style="{color: colorModeButton}" type="number" placeholder="Search for a Number..." v-model="searchNumber" id="home-search-input">
                                    </div>
                                    <div id="filter-confirm">
                                        <v-btn height="100%" :color="colorModeText" :disabled="filterBtnDisabled" @click="page = 1; startSearch();  allowNotification = false" text class="home-search-trigger-area">
                                          <v-icon class="search-trigger-icon" :color="colorModeButton">{{filterSearchEnabledIcon}}</v-icon> Search
                                        </v-btn>
                                    </div>
                                    <div id="filter-remove">
                                        <v-btn height="100%"  :color="colorModeText" @click="searchNumber = ''; filterByState= false, filterByChat= false, searchingParameterSet= false; startSearch(); allowNotification = false " text class="home-search-trigger-area">
                                          <v-icon class="search-trigger-icon" :color="colorModeButton">fas fa-undo-alt</v-icon>  Reset
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:style="{background: darkModeDarkSkinDarken, color: colorModeText}" id="header-titles">
                                <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                    Chat
                                </div>
                                <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                    Customer #
                                </div>
                                <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                    Paid
                                </div>
                                <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                    Credits To Give
                                </div>
                                <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                    Reference
                                </div>
                                <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                    Transaction time
                                </div>
                                <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                    Processed
                                </div>
                                <div v-bind:style="{width: calculatrColumnWidth}" v-if="isAdmin" class="header-title">
                                    Process Time
                                </div>
                            </div>
                        </div>
                        <div id="loading-section"></div>
                        <v-card id="info-content-main" v-bind:style="{background: darkModeDarkSkinLighten}">
                            <v-overlay id="loader-overlay"
                                       absolute="absolute"
                                       :value="loadingOverlay"
                                       opacity="0.9"
                                       :color="darkModeDarkSkinLighten"
                            ></v-overlay>
                            <v-scroll-x-transition>
                            <v-card flat v-if="loadSection" id="info-content"  v-bind:style="{background: darkModeDarkSkinLighten}">
                                <div v-bind:style="{color: colorModeText}"  id="no-payments" v-if="noPayements">
                                    No Orders matching the criteria
                                </div>
                                <div v-bind:style="{color: colorModeText}"  v-else style="height: 5%; width: 100%;" v-for="(orderResponse, index) in orderResponse" :key="index" >
                                    <div id="response-content" v-bind:style="{background: darkModeDarkSkinLighten}">
                                        <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                            {{computeChatName(orderResponse.serviceId)}} {{chatName}}
                                        </div>
                                        <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                            <v-badge
                                                    :color="copiedToClipboardColor"
                                                    right
                                                    overlap
                                            >
                                                <template v-slot:badge>
                                                    <span v-if="showTeleNumber == index" class="badge-span">
                                                        <v-icon style="font-size: 10px" color="white">
                                                            {{copiedToClipboardIcon}}
                                                        </v-icon>
                                                    </span>
                                                </template>
                                                <div @dblclick="viewTransactions(orderResponse)"  @click="copyTelephoneNumber(orderResponse.telephoneNumber)" @mouseenter="showTeleNumber = index" @mouseleave="showTeleNumber = null">
                                                    {{orderResponse.telephoneNumber}}
                                                </div>
                                            </v-badge>
                                        </div>
                                        <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                            {{orderResponse.amount}}   {{orderResponse.paymentCurrency}}
                                        </div>
                                        <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                            {{orderResponse.credit}}
                                        </div>
                                        <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                            <v-badge
                                                    :color="copiedToClipboardColor"
                                                    right
                                                    overlap
                                            >
                                                <template v-slot:badge>
                                                    <span v-if="showOrderNumber == index" class="badge-span">
                                                        <v-icon style="font-size: 10px" color="white">
                                                            {{copiedToClipboardIcon}}
                                                        </v-icon>
                                                    </span>
                                                </template>
                                                <div @click="copyReferenceNumber(orderResponse.transactionId)" @mouseenter="showOrderNumber = index" @mouseleave="showOrderNumber = null">
                                                    {{orderResponse.transactionId}}
                                                </div>
                                            </v-badge>
                                        </div>
                                        <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                            {{new Date(orderResponse.created).toDateString()}}  {{new Date(orderResponse.created).toLocaleTimeString().substr(0,5)}}
                                        </div>
                                        <div v-bind:style="{width: calculatrColumnWidth}" class="header-title">
                                            {{computeProcess(orderResponse)}}
                            <v-scroll-x-transition>
                                            <v-btn x-small @click="processCompleted(orderResponse)"
                                                    :color="processColor"
                                                    text
                                                    icon
                                                    @mousedown="startAlertPayment(orderResponse)"
                                                    @mouseleave="stopAlertPayment"
                                                    @mouseup="stopAlertPayment"
                                                    @touchstartQuickAlarm="startAlertPayment(orderResponse)"
                                                    @touchend="stopAlertPayment"
                                                    @touchcancel="stopAlertPayment"
                                            >
                                                <v-icon style="font-size: 2.5vh">
                                                    {{processIcon}}
                                                </v-icon>
                                            </v-btn>
                            </v-scroll-x-transition>
                                        </div>
                                        <div v-bind:style="{width: calculatrColumnWidth}" v-if="isAdmin" class="header-title">
                                            {{calculateProcessTime[index]}}
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                            </v-scroll-x-transition>
                            <hr v-bind:style="{backgroundColor: darkModeDarkSkinLighten}" style="margin: 0; width: 90%; margin-left: auto; margin-right: auto">

                            <div id="info-footer" v-bind:style="{background: darkModeThird}">
                                <v-pagination v-if="paginationToggle"
                                              style="height: 50%"
                                              circle
                                              :dark="darkMode"
                                              total-visible="10"
                                              v-model="page"
                                              :length="totalPagesFromResponse"
                                              color="#2e2e2e"
                                ></v-pagination>
                            </div>
                        </v-card>
                    </v-card>
                        <v-card flat v-if="openBundleSettings">
                            <div class="card-main-wrapper-outter">
                                    <div class="card-main-wrapper-inner">
                                        <app-bundle-test style="overflow: hidden;"
                                                         :closeBundleScreen="openBundleSettings"
                                                         @bundleScreenModalTrigger="openBundleSettings = $event"
                                        ></app-bundle-test>
                                    </div>
                            </div>
                    </v-card>
                        <v-card flat v-if="openPromoSettings">
                        <div class="card-main-wrapper-outter">
                            <div class="card-main-wrapper-inner">
                                        <app-promo-addon></app-promo-addon>
                            </div>
                        </div>
                    </v-card>
                        <v-card flt v-if="openStats">
                                <div class="card-main-wrapper-outter">
                                    <div class="card-main-wrapper-inner-border">
                                        <app-stats
                                                :statsOpen="updateStats"
                                                :statsUpdate="updateEditedStats"
                                        ></app-stats>
                                    </div>
                                </div>
                        </v-card>
                        <v-card flat v-if="openHelp">
                        <div class="card-main-wrapper-outter">
                            <div class="card-main-wrapper-inner-border">
                                <app-help></app-help>
                            </div>
                        </div>
                    </v-card>
                    </v-card>
                    </v-slide-x-transition>
                </div>
            </div>
            <v-dialog
                      v-model="editNumberModal"
                      scrollable
                      persistent
                      width="60vw"
                      transition="slide-y-transition"
            >
                <v-card dark height="60vh">
                    <div id="edit-modal-header">
                        <div id="edit-modal-header-title">
                            Edit {{editNumberReferenceNumber}}
                        </div>
                        <div id="edit-modal-header-button">
                            <v-btn small @click="editNumberModal = false" icon>
                                <v-icon>fa-times</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <div id="edit-modal-content">
                        <v-badge color="transparent">
                            <template v-slot:badge>
                                <v-icon @click="restoreNumber" color="white">
                                    fas fa-undo
                                </v-icon>
                            </template>
                            <v-text-field style="width: 30vw"
                                    label="Customer Telephone Number"
                                    v-model="customerTelephoneNumber"
                                    :hint="'Customer # is ' + initalNumber"
                            ></v-text-field>
                        </v-badge>
                    </div>
                    <div id="edit-modal-button-area">
                        <div class="edit-modal-button-side">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" rounded ripple light @click="executeRefund()"  @mouseenter="showRefundAlert = true" @mouseleave="showRefundAlert = false"   :color="paymentRefundButtonColour" style="color:rgba(0,0,0,0.5); text-decoration: none !important; width: 70%;" v-bind:style="{color: paymentRefundButtonIconColour}">
                                        <div class="edit-modal-button-text">
                                            {{paymentRefundButtonText}}
                                        </div>
                                        <div class="edit-modal-button-icon">
                                            <v-icon :color="paymentRefundButtonIconColour" style="padding-left: 10%">
                                                fas fa-backspace
                                            </v-icon>
                                        </div>
                                    </v-btn>
                                </template>
                                <span>For Stats Purposes Only</span>
                            </v-tooltip>
                        </div>

                    </div>
                    <div id="edit-modal-save-area">
                        <v-btn @click="saveNumber()" style="width: 50%" dark rounded color="#2e2e2e">
                            Save
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </div>
    </v-app>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { AXIOS } from '../../http-common'
import promoAddon from '@/components/promo/promotions.vue'
import bundles from '@/components/bundle-editor/bundle-edit.vue'
import stats from '@/components/stats/stats.vue'
import misc from '@/components/misc-features/misc.vue'
import announcements from '@/components/announcements/announcements.vue'
import help from '@/components/help/help.vue'

import VueClipboard from 'vue-clipboard2'
import router from '../../router'
Vue.use(Vuetify)
Vue.use(VueClipboard)
export default {
  components: {
    // Promo component
    appPromoAddon: promoAddon,
    appBundleTest: bundles,
    appStats: stats,
    appMisc: misc,
    appAnnouncements: announcements,
    appHelp: help
  },
  data () {
    return {
      celeToggler: false,
      specialEvent: false,
      greetingMessage:"",
      showVersion: true,
      enableGreeting: false,

      editNumberReferenceNumber:"",
      disableSetFilterButton: true,
      currentTime: new Date(),
      filterSearchEnabledIcon:'fas fa-search',
      showAnnouncementBanner: false,
      alertCollapse: true,
      collapseText: false,
      toolbarWidth: '70px',

      darkModeDarkSkinDarken: '',
      darkModeDarkSkinLighten: '',
      darkModeThird: '',
      colorModeText: '',
      colorModeButton: '#74746E',
      darkMode: false,
      darkModeIcon: 'fas fa-sun',
      menuActive: '',
      searchingParameterSet: false,
      filterChatSelected: '',
      filterStatusSelected: '',
      chatOptions: [
        { title: 'UK', id: 1 },
        { title: 'Adult', id: 2 },
        { title: 'Australia', id: 3 }
      ],
      statusOptions: [
        { title: 'Processed', id: 1 },
        { title: 'Unprocessed', id: 0 },
        { title: 'Refunded', id: 3 },
        { title: 'Highlighted', id: 2 }
      ],
      fav: false,
      menu: false,
      message: false,
      hints: true,
      filterByChat: false,
      filterByState: false,
      searchNumber: '',
      filterRefund: '',
      filterService: '',
      filterProcessState: '',
      drawer: null,

      openMisc: false,
      isDev: false,

      favouritePageOverlay: false,

      showSelectedPage: '',

      viewingPage: '',

      logoAPN: require('../../images/logos/APNLogo.png'),

      openTakeMeHomePage: true,
      showContentToggle: true,

      showPageNameToggle: false,

      showIgnoreAlert: false,
      showRefundAlert: false,

      ignoreTrigger: '',
      ignoreButtonColor: '',
      ignoreButtonTextColour: '',

      mask: '447#########',
      value: '447',
      value2: '447',
      errorMessage: '',

      loadSection: false,

      paymentButtonTrigger: true,
      numberSavedSuccess: false,

      y: 'top',
      timeout: 3000,

      editNumberModal: false,
      customerTelephoneNumber: '',
      paymentProcessState: '',
      paymentState: '',
      initalNumber: '',

      paymentRefundButtonText: '',
      paymentRefundButtonColour: '',
      paymentRefundButtonIconColour: '',

      orderAlertObject: {},
      customerNumberDetails: {},

      alertIntervalTime: '',
      alertTimeCounter: '',


      isSafari: false,
      userBrowser: '',

      timeTookToProcess: '',

      updateStats: '',
      updateEditedStats: '',

      selectedBundleId: '',

      accountOptions: [
        { title: 'Orders', icon: 'fas fa-th-list', page: 0 },
        { title: 'Bundles', icon: 'fas fa-cubes', page: 1 },
        { title: 'Promotions', icon: 'fas fa-ad', page: 2 },
        { title: 'Help', icon: 'fas fa-question-circle', page: 6 },
        { title: 'Logout', icon: 'fas fa-sign-out-alt', page: 7 }
      ],

      developerAccountOptions: [
        { title: 'Orders', icon: 'fas fa-th-list' },
        { title: 'Bundles', icon: 'fas fa-cubes' },
        { title: 'Promotions', icon: 'fas fa-ad' },
        { title: 'Stats', icon: 'fas fa-chart-pie' },
        { title: 'Logout', icon: 'fas fa-sign-out-alt' },
        { title: 'Misc', icon: 'fas fa-vial' }
      ],

      callCentreAccountOptions: [
          { title: 'Orders', icon: 'fas fa-th-list', page: 0 },
          { title: 'Help', icon: 'fas fa-question-circle', page: 6 },
          { title: 'Logout', icon: 'fas fa-sign-out-alt', page: 7 }
      ],

      totalElementsNow: '',
      unprocessedPayments: '',

      isAdmin: false,
      copiedToClipboardIcon: 'fas fa-clone',
      copiedToClipboardColor: 'blue',
      showLoadingBar: false,

      loadingOverlay: false,
      hover: '',

      showOrderNumber: false,
      showTeleNumber: false,

      searchActive: '',

      height: '',

      setFilter: undefined,
      setCategory: undefined,

      categorySelectArray: ['Chat', 'Processed'],
      categoryFilterArrayForChat: ['Adult', 'Australia', 'UK'],
      categoryFilterArrayForProcessed: ['Yes', 'No'],
      categoryFilterArray: [''],
      disableFilter: true,

      openBundleSettings: false,

      openPromoSettings: false,

      openStats: false,

      openAnnoucements: false,

      openHelp: false,

      selectedCategory: undefined, // Defines the filter category
      selectedFilter: undefined, // Defines the secondary filter category
      page: 1, // Defines which pagination page should be showed at start
      orderResponse: {}, // Array of order responde data
      paginationToggle: false, // Toggles if pagination option should be showed
      noPayements: false, // Defines if there are 0 order to be displayed according to condition
      filterBtnDisabled: true, // Defines if filter button is disabled

      allowNotification: true,

    }
  },

  computed: {

    calculatrColumnWidth () {
      if (this.isAdmin == true) {
        var columnWidth = '12.5%'
      } else if (this.isAdmin == false) {
        var columnWidth = '14.2%'
      }
      return columnWidth
    },

    calculateProcessTime () {
      return this.orderResponse.map(function (orderResponse) {
        var radical = new Date(orderResponse.created)
        var today = new Date(orderResponse.processTime)
        var diffo = today - radical
        var hoursPassed = Math.floor(diffo / 60)

        if (orderResponse.refund == true) {
          var timeProcessed = 'Refunded'
        } else if (orderResponse.created < '2019-10-30T00:00:00.000') {
          var timeProcessed = '🚫'
        } else if (orderResponse.processTime >= 1440) {
          var timeProcessed = 'Over A Day'
        } else if (orderResponse.processTime == null) {
          var timeProcessed = 'N/A'
        } else if (orderResponse.processTime >= 120) {
          var hoursPassed = Math.floor(orderResponse.processTime / 60)

          var timeProcessed = 'Over ' + hoursPassed + ' Hours'
        } else if (orderResponse.processTime >= 60) {
          var timeProcessed = 'Over 1 Hour'
        } else if (orderResponse.processTime == 0) {
          var timeProcessed = 'Under A Minute'
        } else if (orderResponse.processTime == 1) {
          var timeProcessed = orderResponse.processTime + ' Minute'
        } else if (orderResponse.processTime < 60) {
          var timeProcessed = orderResponse.processTime + ' Minutes'
        }

        return timeProcessed
      })
    }

  },

  watch: {

    'specialEvent': function (se){
      if (se == true){
        setInterval(this.toggleCelebration, 15000)
      }

    },

      'allowNotification': function (v) {
          setTimeout(() => this.allowNotification = true, 2000)
      },

      'menu':function(m){
          if (m == true){
              this.stopInterval()
          }
      },

    filterByChat: function (v){

      if (this.filterByChat == true || this.filterByState == true){
        this.disableSetFilterButton = false
      }
      else {
        this.disableSetFilterButton = true
      }
    },

    filterByState: function (x){

      if (this.filterByState == true || this.filterByChat == true){
        this.disableSetFilterButton = false
      }
      else {
        this.disableSetFilterButton = true
      }
    },

    alertCollapse: function (x) {
      if (x == true) {
        this.toolbarWidth = '70px'
      } else {
        this.toolbarWidth = '100%'
      }
    },

    searchingParameterSet: function (sps) {

      if (sps == true) {
        this.filterBtnDisabled = false
        this.filterSearchEnabledIcon = 'fas fa-search-plus'

      } else if (sps == false) {
        this.filterBtnDisabled = true
        this.filterSearchEnabledIcon = 'fas fa-search'
        
      }
    },

    searchNumber: function () {
      if (this.searchNumber.length != 0) {
        this.filterBtnDisabled = false
      } else if (this.searchNumber.length == 0) {
        this.filterBtnDisabled = true
      }
    },

    showSelectedPage: function (v) {
      this.selectFunction(v)
    },

    alertTimeCounter: function (lc) {
      lc = this.alertTimeCounter
      if (lc == 20) {
        this.executeAlert()
      }
    },

    totalElementsNow: function (v1, v2) {

      if (v2 == '') {
        v2 = v1
      }

      if (v1 != v2 && this.filterByState == false && this.filterByChat == false && this.searchingParameterSet == false && this.allowNotification == true) {
        document.title = '🚨 Chattube - Orders'
        this.sendNotification()
        setTimeout(() => this.updateStats = true, 500)
        setTimeout(() => this.updateStats = false, 1100)
      } else {
        document.title = 'Chattube - Orders'
        this.updateStats = false
      }
    },

    // Applies get request depending on condition
    page: function () {
      this.loadingOverlay = true
      this.showLoadingBar = true
      this.loadSection = false
      setTimeout(() => this.loadSection = true, 500)

      this.calculatedPaginationPage = this.page - 1 // Pagination button number
      this.searchOrders()
    }
  },
  created: function () {
    document.title = 'Chattube - Orders' // Create title for the page
    this.celebrationTrigger()

    // this.getAnnouncement()

    this.checkBrowser()
    setTimeout(() => this.checkBrowser(), 500)
    if (window.$cookies.get('session') == null) {
      location.replace(location.origin + '/topup/login')
    }
    setInterval(this.checkCookies, 1000)
    this.decodeJWT()
    this.searchOrders()
    // this.getAllPaginationOrders() //Get orders on load
     this.startSearch()// Retrieve orders every 30 seconds

    this.totalPagesFromResponse = 1 // On load always show page 1

    this.loadSection = false
    setTimeout(() => this.loadSection = true, 500)
  },

  methods: {

    toggleCelebration(){
      this.celeToggler = !this.celeToggler

      if (this.celeToggler == true){
        this.showVersion = false
        setTimeout(() =>  this.enableGreeting = true, 1000)
      }
      else if (this.celeToggler == false) {
        this.enableGreeting = false
        setTimeout(() =>  this.showVersion = true, 1000)
      }
    },

    celebrationTrigger(){
      var todaysDate = new Date().toISOString().substr(0,10)
      var checkMonth = todaysDate.substr(5,2)
      var checkDay = todaysDate.substr(8,2)
      if (checkMonth == 10 && checkDay == 31){
        this.specialEvent = true
        this.greetingMessage = 'Happy Halloween 🎃'
      }
      else if (checkMonth == 11 && checkDay == 5 ){
        this.specialEvent = true
        this.greetingMessage = 'Happy Bonfire Night 🎆'
      }
      else if (checkMonth == 11 && checkDay == 11 ){
        this.specialEvent = true
        this.greetingMessage = 'Happy Remembrance Day 🌺'
      }
      else if (checkMonth == 12 && checkDay == 24 ){
        this.specialEvent = true
        this.greetingMessage = 'Happy Christmas Eve 🎄'
      }
      else if (checkMonth == 12 && checkDay == 25 ){
        this.specialEvent = true
        this.greetingMessage = 'Merry Christmas 🎁'
      }
      else if (checkMonth == 12 && checkDay == 31 ){
        this.specialEvent = true
        this.greetingMessage = 'New Years Eve 🥳'
      }
      else if (checkMonth == 1 && checkDay == 1 ){
        this.specialEvent = true
        this.greetingMessage = 'Happy New Year 🛌'
      }
      else {
        this.specialEvent = false
      }
    },

      stopInterval () {
          clearInterval(this.every30)
      },
      startSearch() {
          document.title = 'Chattube - Orders'
          this.searchOrders()
          this.every30 = setInterval(this.searchOrders, 10000)
      },

    collapseBanner (state) {
      if (state == true) {
        setTimeout(() => this.alertCollapse = false, 1000)
        setTimeout(() => this.collapseText = true, 1150)
      } else {
        setTimeout(() => this.alertCollapse = true, 2000)
        setTimeout(() => this.collapseText = false, 1750)
      }
    },

    triggerDarkMode () {
      this.darkMode = !this.darkMode
      if (this.darkMode == true) {
        this.darkModeIcon = 'fas fa-moon'
        this.darkModeDarkSkinDarken = 'rgba(46,46,46,1)'
        this.darkModeDarkSkinLighten = '#424242'
        this.darkModeThird = '#424242'
        this.colorModeText = '#FFFFFE'
        this.colorModeButton = '#FFFFFE'
      } else {
        this.darkModeIcon = 'fas fa-sun'
        this.darkModeDarkSkinDarken = '#cccccc'
        this.darkModeDarkSkinLighten = '#FFFFFE'
        this.darkModeThird = '#FFFFFE'
        this.colorModeText = ''
        this.colorModeButton = '#74746E'
      }
    },

    searchOrders () {
      this.showLoadingBar = true
      this.loadingOverlay = true
      const params = new URLSearchParams()
      params.append('telephoneNumber', this.searchNumber)
      if (this.menu == false && this.searchingParameterSet == true) {
        this.applyChatSelected = this.filterChatSelected
        this.applyStatusSelected = this.filterStatusSelected
        if (this.filterByChat == true) { params.append('serviceId', this.applyChatSelected) }
        if (this.filterByState == true) {
          if (this.applyStatusSelected == 3) {
            params.append('refund', true)
          } else {
            params.append('creditProcessed', this.applyStatusSelected)
            params.append('refund', false)
          }
        }
      } else if (this.menu == true && this.searchingParameterSet == true) {
        if (this.filterByChat == true) { params.append('serviceId', this.applyChatSelected) }
        if (this.filterByState == true) {
          if (this.applyStatusSelected == 3) {
            params.append('refund', true)
          } else {
            params.append('creditProcessed', this.applyStatusSelected)
            params.append('refund', false)
          }
        }
      } else if (this.menu == false && this.searchingParameterSet == false) {
        this.applyChatSelected = ''
        this.applyStatusSelected = ''
        { params.append('serviceId', this.applyChatSelected) }
        if (this.filterByState == true) {
          if (this.applyStatusSelected == 3) {
            params.append('refund', true)
          } else {
            params.append('creditProcessed', this.applyStatusSelected)
            params.append('refund', false)
          }
        }
      }
      AXIOS({
        method: 'GET',
        url: 'api/orders/search/?page=' + this.calculatedPaginationPage,
        params,
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        }
      })
        .then(response => {
            this.totalElementsNow = response.data.totalElements

          if (response.data.empty == true && response.data.totalPages == 0 && response.data.numberOfElements == 0) {
            this.noPayements = true
            this.paginationToggle = false
          } else if (response.data.numberOfElements == 0 && response.data.totalPages <= 1 && response.data.empty == true) {
            this.calculatedPaginationPage = this.calculatedPaginationPage - 1
            this.page = this.page - 1
            this.getProcessedPaginationOrders(condition)
            this.showLoadingBar = false
            this.loadSection = true
            this.loadingOverlay = false
          } else {
            this.noPayements = false
            this.orderResponse = response.data.content
            if (response.data.totalPages > 1) {
              this.paginationToggle = true
              this.totalPagesFromResponse = response.data.totalPages
            }
            if (response.data.totalPages <= 1) {
              this.paginationToggle = false
            }
          }
          this.showLoadingBar = false
          this.loadSection = true
          this.loadingOverlay = false
        },
        (err) => {
          // if unauthorised remove cookie and redirect
          if (err.response.status == 401 || err.response.status == 403) {
            this.removeCookie()
          }
        })
    },

    executeRefund () {
      this.paymentRefund = !this.paymentRefund

      if (this.paymentRefund == true) {
        this.paymentRefundButtonText = 'Refunded'
        this.paymentRefundButtonColour = '#2096f3'
        this.paymentRefundButtonIconColour = 'white'
      } else if (this.paymentRefund == false) {
        this.paymentRefundButtonText = 'Refund'
        this.paymentRefundButtonColour = 'white'
        this.paymentRefundButtonIconColour = '#2096f3'
      }
    },

    restoreNumber () {
      this.customerTelephoneNumber = this.initalNumber
    },

    viewTransactions (telNumber) {
      if (this.isAdmin == true) {
        this.editNumberModal = true
        this.editNumberReferenceNumber = telNumber.transactionId
        this.customerNumberDetails = telNumber
        this.initalNumber = telNumber.telephoneNumber
        this.customerTelephoneNumber = telNumber.telephoneNumber
        this.operatorResponseTime = telNumber.processTime
        this.operatorResponseTimeOrginal = telNumber.processTime

        this.paymentState = telNumber.creditProcessed
        this.paymentRefund = telNumber.refund

        if (this.paymentRefund == true) {
          this.paymentRefundButtonText = 'Refunded'
          this.paymentRefundButtonColour = '#2096f3'
          this.paymentRefundButtonIconColour = 'white'
        } else if (this.paymentRefund == false) {
          this.paymentRefundButtonText = 'Refund'
          this.paymentRefundButtonColour = 'white'
          this.paymentRefundButtonIconColour = '#2096f3'
        }

        if (this.operatorResponseTime == null) {
          this.ignoreButtonColor = '#f54336'
          this.ignoreButtonTextColour = 'white'
        } else if (this.operatorResponseTime != null) {
          this.ignoreButtonColor = 'white'
          this.ignoreButtonTextColour = '#f54336'
        }
      }
    },

    saveNumber () {
      if (this.isAdmin == true) {
        setTimeout(() => this.updateEditedStats = true, 500)
        setTimeout(() => this.updateEditedStats = false, 1000)
        AXIOS({
          method: 'POST',
          url: 'api/order/',
          headers: {
            Authorization: 'Bearer ' + window.$cookies.get('session')
          },
          data: {
            id: this.customerNumberDetails.id,
            amount: this.customerNumberDetails.amount,
            created: this.customerNumberDetails.created,
            credit: this.customerNumberDetails.credit,
            refund: this.paymentRefund,
            creditProcessed: this.customerNumberDetails.creditProcessed,
            customerPayPalId: this.customerNumberDetails.customerPayPalId,
            orderNumber: this.customerNumberDetails.orderNumber,
            payPalCaptureTime: this.customerNumberDetails.payPalCaptureTime,
            paymentCurrency: this.customerNumberDetails.paymentCurrency,
            serviceId: this.customerNumberDetails.serviceId,
            telephoneNumber: this.customerTelephoneNumber,
            transactionId: this.customerNumberDetails.transactionId,
            processTime: this.operatorResponseTime
          }

        })
          .then(response => {
            this.searchOrders()

            this.numberSavedSuccess = true
            this.editNumberModal = false
            this.showLoadingBar = false
            this.loadSection = true
            this.loadingOverlay = false
          })
      }
    },
    executeAlert () {
      setTimeout(() => this.updateEditedStats = true, 500)
      setTimeout(() => this.updateEditedStats = false, 1000)
      if (this.alertState == 1 || this.alertState == 0) {
        this.alertTrigger = 2
      } else if (this.alertState == 2 && this.isAdmin == true) {
        this.alertTrigger = 1
      }
      AXIOS({
        method: 'POST',
        url: 'api/order/',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        },
        data: {
          id: this.alertId,
          amount: this.orderAlertObject.amount,
          created: this.orderAlertObject.created,
          credit: this.orderAlertObject.credit,
          refund: this.orderAlertObject.refund,
          creditProcessed: this.alertTrigger,
          customerPayPalId: this.orderAlertObject.customerPayPalId,
          orderNumber: this.orderAlertObject.orderNumber,
          payPalCaptureTime: this.orderAlertObject.payPalCaptureTime,
          paymentCurrency: this.orderAlertObject.paymentCurrency,
          serviceId: this.orderAlertObject.serviceId,
          telephoneNumber: this.orderAlertObject.telephoneNumber,
          transactionId: this.orderAlertObject.transactionId,
          processTime: this.orderAlertObject.processTime
        }

      })
        .then(response => {
          this.searchOrders()
          this.showLoadingBar = false
          this.loadingOverlay = false
          this.loadSection = true
        })
    },
    startAlertPayment (order) {
      if (!this.alertIntervalTime && order.refund == false) {
        this.alertIntervalTime = setInterval(() => this.alertTimeCounter++, 50)
        this.orderAlertObject = order
        this.alertId = order.id
        this.alertState = order.creditProcessed
      }
    },
    stopAlertPayment () {
      clearInterval(this.alertIntervalTime)
      this.alertIntervalTime = false
      this.alertTimeCounter = 0
      this.orderAlertObject = {}
      this.alertId = ''
    },
    checkBrowser () {
      var browser = (function () {
        var test = function (regexp) { return regexp.test(window.navigator.userAgent) }
        switch (true) {
          case test(/edge/i): return 'edge'
          case test(/opr/i) && (!!window.opr || !!window.opera): return 'opera'
          case test(/chrome/i) && !!window.chrome: return 'chrome'
          case test(/trident/i) : return 'ie'
          case test(/firefox/i) : return 'firefox'
          case test(/safari/i): return 'safari'
          default: return 'other'
        }
      })()
      this.userBrowser = browser
      if (this.userBrowser != 'safari') {
        this.isSafari = false
        this.notificationsForOrders()
      } else {
        this.isSafari = true
      }
    },

    // Selects which page will be shown
    selectFunction (i) {
      this.showContentToggle = false
      setTimeout(() => this.showContentToggle = true, 250)
      this.showPageNameToggle = false
      setTimeout(() => this.showPageNameToggle = true, 250)
      this.showSelectedPage = i
      if (this.showSelectedPage == 0) { // ORDERS
        setTimeout(() => this.openBundleSettings = false, 100)
        setTimeout(() => this.openPromoSettings = false, 100)
        setTimeout(() => this.openStats = false, 100)
        setTimeout(() => this.openMisc = false, 100)
        setTimeout(() => this.openAnnoucements = false, 100)
          setTimeout(() => this.openHelp = false, 100)
        this.viewingPage = 'Orders'
        document.title = 'Chattube - Orders' // Create title for the page
        setTimeout(() => this.openTakeMeHomePage = true, 250)
        // this.openTakeMeHomePage = true
        setTimeout(() => this.resizeWindow(), 500) // On mounted checks div area and applies other styling for it
      } else if (this.showSelectedPage == 1) { // BUNDLES
        setTimeout(() => this.openTakeMeHomePage = false, 100)
        setTimeout(() => this.openPromoSettings = false, 100)
        setTimeout(() => this.openStats = false, 100)
        setTimeout(() => this.openMisc = false, 100)
        setTimeout(() => this.openAnnoucements = false, 100)
          setTimeout(() => this.openHelp = false, 100)
        this.viewingPage = 'Bundles'
        this.openBundleSettings = true
      } else if (this.showSelectedPage == 2) { // PROMOTIONS
        setTimeout(() => this.openBundleSettings = false, 100)
        setTimeout(() => this.openTakeMeHomePage = false, 100)
        setTimeout(() => this.openStats = false, 100)
        setTimeout(() => this.openMisc = false, 100)
        setTimeout(() => this.openAnnoucements = false, 100)
          setTimeout(() => this.openHelp = false, 100)
        this.viewingPage = 'Promotions'
        this.openPromoSettings = true
      } else if (this.showSelectedPage == 3) { // STATS
        setTimeout(() => this.openBundleSettings = false, 100)
        setTimeout(() => this.openPromoSettings = false, 100)
        setTimeout(() => this.openTakeMeHomePage = false, 100)
        setTimeout(() => this.openMisc = false, 100)
        setTimeout(() => this.openAnnoucements = false, 100)
          setTimeout(() => this.openHelp = false, 100)
        this.viewingPage = 'Stats'
        this.openStats = true
      } else if (this.showSelectedPage == 4) {
        setTimeout(() => this.openBundleSettings = false, 100)
        setTimeout(() => this.openPromoSettings = false, 100)
        setTimeout(() => this.openTakeMeHomePage = false, 100)
        setTimeout(() => this.openStats = false, 100)
        setTimeout(() => this.openAnnoucements = false, 100)
          setTimeout(() => this.openHelp = false, 100)
        this.viewingPage = 'Misc'
        this.openMisc = true
      } else if (this.showSelectedPage == 5) {
        setTimeout(() => this.openBundleSettings = false, 100)
        setTimeout(() => this.openPromoSettings = false, 100)
        setTimeout(() => this.openTakeMeHomePage = false, 100)
        setTimeout(() => this.openStats = false, 100)
        setTimeout(() => this.openMisc = false, 100)
        setTimeout(() => this.openHelp = false, 100)
        this.viewingPage = 'Announcements'
        this.openAnnoucements = true
      } else if (this.showSelectedPage == 6) {
        setTimeout(() => this.openBundleSettings = false, 100)
        setTimeout(() => this.openPromoSettings = false, 100)
        setTimeout(() => this.openTakeMeHomePage = false, 100)
        setTimeout(() => this.openStats = false, 100)
        setTimeout(() => this.openAnnoucements = false, 100)
        setTimeout(() => this.openMisc = false, 100)
        this.viewingPage = 'Help'
        this.openHelp = true
      } else if (this.showSelectedPage == 7) { // LOGOUT
        this.removeCookie()
      }
    },

    callCentreSelectFunction (i) {
      if (i == 0) {
        this.removeCookie()
      }
    },

    // Decodes JWT for session storage later toggles a box option
    decodeJWT () {
      const base64Url = window.$cookies.get('session').split('.')[1]
      const base64 = base64Url.replace('-', '+').replace('_', '/')
      const decodedData = JSON.parse(Buffer.from(base64, 'base64').toString('binary'))
      if (decodedData.sub == 1) {
        this.isAdmin = true
      } else if (decodedData.sub == 3) {
        this.isDev = true
      } else {
        this.isAdmin = false
        this.isDev = false
      }
    },
    copyTelephoneNumber (telNumber) {
      this.copiedText = telNumber
      this.$copyText(this.copiedText)
      this.copiedToClipboardColor = 'green'
      this.copiedToClipboardIcon = 'fas fa-check'
      setTimeout(() => this.copiedToClipboardColor = 'blue', 350)
      setTimeout(() => this.copiedToClipboardIcon = 'fas fa-clone', 350)
    },

    copyReferenceNumber (refNumber) {
      this.copiedText = 'PayPal - ' + refNumber
      this.$copyText(this.copiedText)
      this.copiedToClipboardColor = 'green'
      this.copiedToClipboardIcon = 'fas fa-check'
      setTimeout(() => this.copiedToClipboardColor = 'blue', 350)
      setTimeout(() => this.copiedToClipboardIcon = 'fas fa-clone', 350)
    },

    resizeWindow () {
      if (this.openTakeMeHomePage == true) {
        this.windowSize = { x: document.getElementById('filter-category').clientHeight }
        this.height = this.windowSize.x + 'px'
      } else {
        this.windowSize = '0'
        this.height = '0'
      }
    },

    // Removes user cookies and logout user
    removeCookie () {
      clearInterval(this.every30)
      clearInterval(this.annoucement30)
      window.$cookies.remove('session')
      location.replace(location.origin + '/topup/login')
    },

    checkCookies () {
      if ($cookies.get('session') == null) {
        location.replace(location.origin + '/topup/login')
        window.$cookies.remove('session')
      }
    },

    // Update record as processed and automatically to a get request depending on condition
    processCompleted (orderResponse) {
      if (orderResponse.creditProcessed == 1 || orderResponse.creditProcessed == 2) {

      } else {
        setTimeout(() => this.updateEditedStats = true, 500)
        setTimeout(() => this.updateEditedStats = false, 1000)



        // var createdTime = new Date(orderResponse.created)
        // var nowTime = new Date()
        // var difference = nowTime - createdTime
        // this.minutesTookToProcess = Math.floor(difference / 60000)




        this.showLoadingBar = true
        // this.loadSection = false
        // setTimeout(() => this.loadSection = true,500);
        this.loadingOverlay = true

        AXIOS({
          method: 'POST',
          url: 'api/order/',
          headers: {
            Authorization: 'Bearer ' + window.$cookies.get('session')
          },
          data: {
            id: orderResponse.id,
            amount: orderResponse.amount,
            created: orderResponse.created,
            credit: orderResponse.credit,
            creditProcessed: 1,
            refund: orderResponse.refund,
            customerPayPalId: orderResponse.customerPayPalId,
            orderNumber: orderResponse.orderNumber,
            payPalCaptureTime: orderResponse.payPalCaptureTime,
            paymentCurrency: orderResponse.paymentCurrency,
            serviceId: orderResponse.serviceId,
            telephoneNumber: orderResponse.telephoneNumber,
            transactionId: orderResponse.transactionId,

          }

        })
          .then(response => {
            this.searchOrders()
            this.showLoadingBar = false
            this.loadSection = true
            this.loadingOverlay = false
          })
      }
    },

    // Assigns a icon and color to order, to identify if processed or not
    computeProcess (process) {
      if (process.creditProcessed == 0 && process.refund == false) {
        this.processIcon = 'fas fa-exclamation-circle'
        this.processColor = '#FF0000'
      } else if (process.creditProcessed == 1 && process.refund == false) {
        this.processIcon = 'fas fa-check-circle'
        this.processColor = '#5cb85c'
      } else if (process.creditProcessed == 2) {
        this.processIcon = 'fas fa-exclamation-triangle'
        this.processColor = 'orange'
      } else if (process.refund == true) {
        this.processIcon = 'fas fa-backspace'
        this.processColor = 'blue'
      }
    },
    // Assigns a computed name to the service where user made payment to
    computeChatName (id) {
      if (id == 1) {
        this.chatName = 'UK'
      } else if (id == 2) {
        this.chatName = 'Adult'
      } else if (id == 3) {
        this.chatName = 'Australia'
      }
    },

    // Gets paginated orders depending on processed condition

    // Gets paginated orders depending on chat condition

    notificationsForOrders () {
      Notification.requestPermission().then(function (result) {
        if (result === 'denied') {
          return
        }
        if (result === 'default') {

        }
        // Do something with the granted permission.
      })
    },

    sendNotification (body, icon, title) {
      var options = {
        body: 'New Payment',
        data: 'A new payment has been received please process it as soon as possible',
        icon: 'https://s3-eu-west-1.amazonaws.com/www.txtitchat.com/APN-Logo-01.png',
        image: 'https://s3-eu-west-1.amazonaws.com/www.txtitchat.com/APN-Logo-01.png',
        badge: 'https://s3-eu-west-1.amazonaws.com/www.txtitchat.com/APN-Logo-01.png'
      }
      var title = 'PRS PayPal'
      var n = new Notification(title, options)
    }
  }
}
</script>

<style>

    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;

    }

    #panel-header {
        height: 7.5%;
        width: 100%;

        font-size: 4vh;

        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        background-color: #2e2e2e;
    }

    #panel-content {
        height: 92.5%;
        width: 100%;

    }

    #dashboard {

        height: 100%;
        width: 100%;

    }

    #dashboard-info {

        height: 100%;
        width: 100%;

    }

    #info-header {

        height: 10%;
        width: 100%;
        /*background-color: white;*/

    }

    #info-content {

        height: 84%;
        width: 100%;
        /*background-color: white;*/
        border-radius: 1px;

    }

    #info-footer {
        height: 6%;

        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    #header-text {
        width: 100%;
        height: 50%;

    }

    #header-titles {

        width: 100%;
        height: 50%;
        font-weight: bold;
        background-color: rgba(0,0,0,0.2);

    }

    .header-title {

        float: left;
        /*width: 12.5%;*/
        height: 100%;
        font-size: 1vw;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    #response-content {

        width: 100%;
        background-color: white;
        height: 100%;
        font-size: 1vw;

    }

    #response-content:hover {

        width: 100%;
        background-color: rgba(0,0,0,0.1);
        height: 100%;
        font-size: 1vw;

    }

    #text-functions {
        width: 100%;
        height: 100%;
        /*background-color: white;*/
        /*ARTIS*/

    }
    #filter-category {
        width: 45%;
        height: 100%;
        float: left;

    }

    #filter-confirm {
        width: 10%;
        height: 100%;

        float: left;
        margin: 0;

    }

    #filter-remove {
        width: 10%;
        height: 100%;
        float: left;
        margin: 0;
    }

    #no-payments {

        font-size: 3vw;
        height: 100%;
        width: 100%;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(0,0,0,0.5);

    }

    .theme--light.v-pagination .v-pagination__item {
        height: 4.25vh;
        min-width: 4.25vh !important;
        font-size: 10px;
    }
    .v-pagination .v-pagination__navigation{
        height: 4.25vh !important;
        width: 4.25vh !important;
    }
    .v-pagination__navigation .v-icon{
        font-size: 20px !important;
    }
    #home-favourite-page-card {
        height: 80vh; width: 70vw;
    }
    #home-favourite-page-card-title {
        width: 100%; height: 20%; color:rgba(0,0,0,0.7); display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 4vh
    }
    #home-favourite-page-card-info-alert {
        width: 100%; height: 10%;color:rgba(0,0,0,0.7); font-size: 2.35vh
    }
    #home-favourite-page-card-content {
        width: 100%; height: 70%;
    }
    .home-favourite-page-content-info{
        width: 50%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; padding-right: 5%; padding-left: 5%; padding-top: 2%; padding-bottom: 2%;
    }
    .home-favourite-selection-card {
        width: 100%; height: 100%!important;
    }
    .home-favourite-selection-card {
        width: 100%; height: 50%; display: flex; justify-content: center; align-items: center; background-color: #e1b384;
    }
    .home-favourite-selection-card-text {
        width: 100%; height: 40%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 2vw;
    }
    #navigation-drawer {
        padding-right: 10px; padding-left: 10px; border-top-left-radius: 10px; border-bottom-left-radius: 10px;
    }
    #navigation-drawer-top-area {
        width: 100%; height: 5%; display: flex; justify-content: center; align-items: center; padding-top: 5%
    }
    .navigation-drawer-top-section {
        width: 33%; height: 100%; float: left; display: flex; justify-content: center; align-items: center
    }
    .navigation-drawer-icons {
        color: white!important; font-size: 17.5px!important; padding-bottom: 50px!important;
    }
    #drawer-version-section {
        position: absolute; bottom: 0; height: 5%; width: 100%; color:white; font-size: 10px; display: flex; justify-content: center; align-items: center; padding-left: 10%
    }
    .drawer-version-section-inner {
      width: 100%;
      height: 100%;
      display: flex; justify-content: center; align-items: center;
    }
    #drawer-version-section-pill {
        color:black ;margin-left: 5% ;height: 15px; width: 35px; font-size: 7.5px; display: flex; justify-content: center; align-items: center
    }
    #panel-header-content {
        width: 100%; height: 100%; color:white
    }
    #panel-viewing-page {
        display: flex; justify-content: center; align-items: center; height: 100%;
    }
    #drawer-button-area {
        float: right; position: absolute; right: 3%;
    }
    #main-parent-area {
        width: 100%; height: 100%
    }
    #home-search-empty-area {
        width: 15%; height: 100%; float: left;
    }
    #home-search-area {
        width: 5%; height: 100%; float: left; display: flex; justify-content: center; align-items: center;
    }
    #home-search-list-card {
        width: 40vw; height: 55vh;
    }
    #home-search-primary-filter {
        width: 40%; height: 100%; float: left;
    }
    #home-search-secondary-filter {
        width: 60%; height: 100%; float: left
    }
    .search-primary-more {
        width: 100%; height: 50%; display: flex; align-items: center; justify-content: center
    }
    .search-secondary-more {
        width: 100%; height: 50%; display: flex; align-items: center; padding-left: 5%
    }
    #home-search-input {
        width: 100%; height: 100%; padding-left: 1%; padding-right: 10%; font-size: 2.5vh
    }
    .home-search-trigger-area {
        width: 100%; height: 100%; margin: 0; font-size: 1.6vh!important; text-decoration: none!important;
    }
    .search-trigger-icon {
        padding-right: 7.5%; font-size: 2.5vh!important;
    }
    #info-content-main {
        height: 100%; width: 100%;
    }
    #loader-overlay {
        width: 100%; height: 100%
    }
    .badge-span {
        display: flex; justify-content: center; align-items: center;
    }
    #edit-modal-header {
        width: 100%; height: 15%; font-weight: bold; font-size: 3vh
    }
    #edit-modal-header-title {
        padding-left: 10% ;width: 90%; height: 100%; display: flex; justify-content: center; align-items: center; float: left
    }
    #edit-modal-header-button {
        width: 10%; height: 100%; display: flex; justify-content: center; align-items: center; float: left
    }
    #edit-modal-content {
        width: 100%; height: 45%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 3vh; padding-right: 10%; padding-left: 10%
    }
    #edit-modal-button-area {
        width: 100%; height: 20%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 3vh
    }
    .edit-modal-button-side {
        width: 50%; height: 100%; margin-left: auto; margin-right: auto;
    }
    .edit-modal-button-text {
        width: 80%; height: 100%; float: left
    }
    .edit-modal-button-icon {
        width: 20%; height: 100%; float: left
    }
    #edit-modal-save-area {
        width: 100%; height: 20%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 3vh
    }
    .card-main-wrapper-outter {
        height: 100vh; width: 100%; overflow: hidden;
    }
    .card-main-wrapper-inner {
        height: 100%; width: 100%; overflow: hidden;
    }
    .card-main-wrapper-inner-border {
        height: 92.5%; width: 100%; overflow: hidden;
    }
    .home-fav-page-icon {
        width: 100%; height: 50%; display: flex; justify-content: center; align-items: center;
    }
    .home-fav-page-text {
        width: 100%; height: 20%; display: flex; justify-content: center; align-items: center; font-size: 4vh;
    }


</style>
